module.exports = __webpack_public_path__ + "assets/img/78a5-cc.svg";